import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const TimesIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 20 20", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            {/* <rect style={{ fill: "none" }} width="20" height="20" transform="translate(20 20) rotate(-180)" /> */}
            <rect
                x="9.4"
                y="-0.17"
                width="1.2"
                height="20.36"
                transform="translate(-4.15 10) rotate(-45)"
            />
            <rect
                x="-0.18"
                y="9.38"
                width="20.36"
                height="1.2"
                transform="translate(-4.13 9.99) rotate(-45)"
            />
        </SvgIcon>
    );
};
